
export const updateDocumentTitle = (title: string) => {
  document.title = title;
};

export const updateMetaDescription = (description: string) => {
  let metaDescription = document.querySelector('meta[name="description"]');
  if (!metaDescription) {
    metaDescription = document.createElement('meta');
    metaDescription.setAttribute('name', 'description');
    document.head.appendChild(metaDescription);
  }
  metaDescription.setAttribute('content', description);
};

export const updateCanonicalUrl = (path: string) => {
  let canonicalLink = document.querySelector('link[rel="canonical"]');
  if (!canonicalLink) {
    canonicalLink = document.createElement('link');
    canonicalLink.setAttribute('rel', 'canonical');
    document.head.appendChild(canonicalLink);
  }
  canonicalLink.setAttribute('href', `https://carolinatrophyroofs.com${path}`);
};

export const updateRobotsTag = (path: string) => {
  let robotsTag = document.querySelector('meta[name="robots"]');
  if (!robotsTag) {
    robotsTag = document.createElement('meta');
    robotsTag.setAttribute('name', 'robots');
    document.head.appendChild(robotsTag);
  }
  
  // Prevent indexing of admin pages, allow everything else
  if (path.includes('Blog-Page-Builder') || path.includes('admin') || path === '/auth') {
    robotsTag.setAttribute('content', 'noindex, nofollow');
  } else {
    robotsTag.setAttribute('content', 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1');
  }
};

export const removeExistingSchema = () => {
  // Remove ALL existing schema scripts to prevent conflicts
  const existingSchemas = document.querySelectorAll('script[type="application/ld+json"]');
  existingSchemas.forEach(schema => schema.remove());
};

export const addSchemaToHead = (schema: object) => {
  const schemaScript = document.createElement('script');
  schemaScript.setAttribute('type', 'application/ld+json');
  schemaScript.textContent = JSON.stringify(schema);
  document.head.appendChild(schemaScript);
};
